import { getCurrentUser } from '../../api/auth';
import { loadReport, saveReport } from '../../api/cashReports';

async function processCashReport(dateKey, amountToRemove) {
  try {
    if (amountToRemove <= 0) {
      console.log('No amount to remove from cash register.');
      return;
    }

    const user = await getCurrentUser();
    if (!user) throw new Error('User not authenticated');

    const userId = user.id;
    let cashRegister = await loadReport(dateKey, userId);

    // If no report exists, initialize an empty register
    if (!cashRegister || !Array.isArray(cashRegister)) {
      console.log('No existing cash report found, creating a new one.');
      cashRegister = [
        { id: 1, item: "5€", value: 5, quantity: 0 },
        { id: 2, item: "10€", value: 10, quantity: 0 },
        { id: 3, item: "20€", value: 20, quantity: 0 },
        { id: 4, item: "50€", value: 50, quantity: 0 },
        { id: 5, item: "100€", value: 100, quantity: 0 },
        { id: 13, item: "50 Cents", value: 0.5, quantity: 0 },
        { id: 14, item: "1€ Coin", value: 1, quantity: 0 },
        { id: 15, item: "2€ Coin", value: 2, quantity: 0 },
      ];
    }

    console.log('Initial cash register:', cashRegister);
    console.log(`Amount to remove: ${amountToRemove} EUR`);

    // Calculate total cash available
    const totalCash = cashRegister.reduce((sum, entry) => sum + entry.value * entry.quantity, 0);
    if (totalCash < amountToRemove) {
      console.warn(`Insufficient cash in register: ${totalCash} EUR available, ${amountToRemove} EUR needed.`);
      return;
    }

    let remainingAmount = amountToRemove;
    // Sort denominations descending to prioritize larger bills/coins
    const sortedDenominations = [...cashRegister].sort((a, b) => b.value - a.value);

    for (const entry of sortedDenominations) {
      if (remainingAmount <= 0) break;

      const available = entry.quantity;
      const value = entry.value;
      const needed = Math.floor(remainingAmount / value);
      const toRemove = Math.min(available, needed);

      if (toRemove > 0) {
        entry.quantity -= toRemove;
        remainingAmount -= toRemove * value;
        remainingAmount = Math.round(remainingAmount * 100) / 100; // Avoid floating-point errors
        console.log(`Removed ${toRemove} x ${value} EUR (${entry.item}), remaining amount: ${remainingAmount} EUR`);
      }
    }

    if (remainingAmount > 0) {
      console.warn(`Could not remove exact amount. Remaining: ${remainingAmount} EUR`);
    } else {
      console.log('Successfully removed the target amount from cash register.');
    }

    // Update totals for each entry
    cashRegister.forEach(entry => {
      entry.total = (entry.value * entry.quantity).toFixed(2);
    });

    console.log('Updated cash register:', cashRegister);
    await saveReport(dateKey, cashRegister);
  } catch (error) {
    console.error('processCashReport error:', error.message);
  }
}

export { processCashReport };
